/**
 * Gratis-Geschenke (hutch&putch)
 *
 * 1. Abgleich im Warenkorb: Nach jedem Refresh von Drawer oder Warenkorbseite
 *    (on:cart:after-merge) liest das Skript aus der Belohnungsleiste
 *    (snippets/hp-rewards-bar.liquid) den bezahlten Warenwert und die Geschenk-Zeilen und
 *    bringt den Warenkorb in den passenden Zustand: Geschenk ab Schwelle hinzufuegen,
 *    darunter entfernen, Menge immer 1. Danach on:cart:change, das Theme rendert neu.
 *    Die Zeilen tragen die Eigenschaft _hp_gift (Stufe "1" oder "2"). Den Preis von 0 EUR
 *    setzt der automatische Rabatt im Admin, nicht dieses Skript.
 *
 * 2. Produktseite: Die Box aus snippets/hp-gift-promo.liquid rechnet Warenkorb plus
 *    aktuelle Variante mal Menge, hakt erreichte Geschenke ab und nennt nur den naechsten Schritt.
 *
 * Warenkorb-Aufrufe per XMLHttpRequest: Apps im Shop patchen window.fetch, und die
 * Wrapper verschlucken bei Cart-Requests gelegentlich den Body.
 */
(function () {
  'use strict';

  if (window.HpGifts) return;
  window.HpGifts = { version: 1 };

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_TRIES_PER_STATE = 2;
  var tries = {};
  var failedTiers = {};
  var busy = false;
  var queued = false;
  var confirmTimer = null;

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function money(cents) {
    return euro.format(cents / 100);
  }

  function readConfig() {
    var el = document.querySelector('script[data-hp-gift-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function request(method, path, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, ROOT + path);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (e) {
            resolve(null);
          }
        } else {
          reject(xhr);
        }
      };
      xhr.onerror = function () { reject(xhr); };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  /* ---------- Warenkorb-Zustand aus der Belohnungsleiste ---------- */

  function readState() {
    var root = document.querySelector('[data-hp-rewards]');
    if (!root) return null;
    var raw = root.getAttribute('data-hp-lines') || '';
    var lines = raw.split(';').filter(Boolean).map(function (part) {
      var p = part.split('~');
      return { tier: p[0], key: p[1], qty: parseInt(p[2], 10) || 0, variant: parseInt(p[3], 10) || 0 };
    });
    return {
      paid: parseInt(root.getAttribute('data-hp-paid'), 10) || 0,
      lines: lines,
      signature: root.getAttribute('data-hp-paid') + '|' + raw
    };
  }

  function planOps(state, cfg) {
    var removals = [];
    var adds = [];
    var tiers = cfg.tiers || [];

    tiers.forEach(function (t) {
      var own = state.lines.filter(function (l) { return l.tier === t.tier && l.variant === t.variant; });
      var wanted = state.paid >= t.threshold && !failedTiers[t.tier];
      if (wanted) {
        if (own.length === 0) {
          adds.push(t);
        } else {
          if (own[0].qty !== 1) removals.push({ key: own[0].key, qty: 1 });
          own.slice(1).forEach(function (l) { removals.push({ key: l.key, qty: 0 }); });
        }
      } else {
        own.forEach(function (l) { removals.push({ key: l.key, qty: 0 }); });
      }
    });

    // Geschenk-Zeilen ohne passende Stufe, zum Beispiel nach Tausch des Geschenks in den Einstellungen.
    state.lines.forEach(function (l) {
      var known = tiers.some(function (t) { return t.tier === l.tier && t.variant === l.variant; });
      if (!known) removals.push({ key: l.key, qty: 0 });
    });

    return { removals: removals, adds: adds };
  }

  function showUnlocked(cfg, titles) {
    var box = document.querySelector('[data-hp-cart-confirm]');
    if (!box || !titles.length || !cfg.unlocked) return;
    var text = box.querySelector('.hp-cart-confirm__text');
    if (!text) return;
    if (!text.hasAttribute('data-hp-default')) text.setAttribute('data-hp-default', text.textContent);
    text.textContent = cfg.unlocked.replace('[title]', titles.join(' + '));
    box.classList.remove('is-visible');
    void box.offsetWidth;
    box.classList.add('is-visible', 'is-hp-gift');
    clearTimeout(confirmTimer);
    confirmTimer = setTimeout(function () {
      box.classList.remove('is-visible', 'is-hp-gift');
      setTimeout(function () { text.textContent = text.getAttribute('data-hp-default'); }, 400);
    }, 5000);
  }

  function sync() {
    var cfg = readConfig();
    var state = readState();
    if (!cfg || !state) return;
    if (busy) {
      queued = true;
      return;
    }

    var plan = planOps(state, cfg);
    if (!plan.removals.length && !plan.adds.length) return;

    tries[state.signature] = (tries[state.signature] || 0) + 1;
    if (tries[state.signature] > MAX_TRIES_PER_STATE) return;

    busy = true;
    var chain = Promise.resolve();
    plan.removals.forEach(function (op) {
      chain = chain.then(function () {
        return request('POST', 'cart/change.js', { id: op.key, quantity: op.qty });
      });
    });

    var added = [];
    if (plan.adds.length) {
      chain = chain.then(function () {
        return request('POST', 'cart/add.js', {
          items: plan.adds.map(function (t) {
            return { id: t.variant, quantity: 1, properties: { _hp_gift: t.tier } };
          })
        }).then(function () {
          plan.adds.forEach(function (t) { added.push(t.title); });
        }, function () {
          // Nicht lieferbar oder nicht veroeffentlicht: fuer diesen Seitenaufruf nicht mehr versuchen.
          plan.adds.forEach(function (t) { failedTiers[t.tier] = true; });
        });
      });
    }

    chain.catch(function () {}).then(function () {
      busy = false;
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      if (added.length) showUnlocked(cfg, added);
      if (queued) {
        queued = false;
        setTimeout(sync, 0);
      }
    });
  }

  /* ---------- Produktseite ---------- */

  function initPromo(box) {
    var prices = {};
    try {
      prices = JSON.parse(box.getAttribute('data-hp-prices') || '{}');
    } catch (e) {}
    var product = box.closest('.js-product') || document;
    var form = product.querySelector('form.js-product-form') || product.querySelector('form[action*="/cart/add"]');
    var status = box.querySelector('[data-hp-gift-status]');
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-hp-threshold]'));
    var strNext = box.getAttribute('data-hp-str-next') || '';
    var strDone = box.getAttribute('data-hp-str-done') || '';
    var cartPaid = null;

    function currentItemCents() {
      if (!form) return 0;
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var price = idInput ? prices[idInput.value] : 0;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      return (price || 0) * qty;
    }

    function render() {
      if (cartPaid === null) return;
      var total = cartPaid + currentItemCents();
      var count = rows.length;
      var progress = 0;
      var prev = 0;
      var next = null;
      var done = [];
      // Stufen stehen in gleichen Abstaenden, der Fuellstand laeuft stueckweise (wie in hp-rewards-bar).
      rows.forEach(function (row, i) {
        var t = parseInt(row.getAttribute('data-hp-threshold'), 10) || 0;
        var ok = total >= t;
        row.classList.toggle('is-reached', ok);
        if (ok) {
          done.push(row.getAttribute('data-hp-name'));
          if (!next) {
            progress = (i + 1) / count;
            prev = t;
          }
        } else if (!next) {
          next = { t: t, reward: row.getAttribute('data-hp-reward') };
          progress = (i + Math.max(0, total - prev) / Math.max(1, t - prev)) / count;
        }
      });
      box.style.setProperty('--hp-progress', String(Math.min(1, progress)));
      status.innerHTML = next
        ? strNext.replace('[amount]', money(next.t - total)).replace('[rewards]', next.reward)
        : strDone.replace('[rewards]', done.join(' + '));
    }

    function paidFromCart(cart) {
      var sum = 0;
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._hp_gift) return;
        sum += it.final_line_price || 0;
      });
      return Math.max(0, sum - (cart.cart_level_discount_applications || []).reduce(function (s, d) {
        return s + (d.total_allocated_amount || 0);
      }, 0));
    }

    function refreshCartPaid() {
      var state = readState();
      if (state) {
        cartPaid = state.paid;
        render();
        return;
      }
      request('GET', 'cart.js').then(function (cart) {
        cartPaid = cart ? paidFromCart(cart) : 0;
        render();
      }, function () {
        cartPaid = 0;
        render();
      });
    }

    if (form) {
      form.addEventListener('change', render);
      form.addEventListener('input', render);
      form.addEventListener('click', function () { setTimeout(render, 0); });
    }
    if (product !== document) product.addEventListener('on:variant:change', function () { setTimeout(render, 0); });
    document.addEventListener('on:cart:after-merge', refreshCartPaid);
    refreshCartPaid();
  }

  /* ---------- Start ---------- */

  function init() {
    document.addEventListener('on:cart:after-merge', function () { setTimeout(sync, 0); });
    document.querySelectorAll('[data-hp-gift-promo]').forEach(initPromo);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
